/*
 * Copyright (c) 2026. Tooling Team
 */

import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { useGetMedDomainEISBuildSummaryByIdQuery } from "../app/services/medDomainEISApi";
import { setMedDomainBuildSummaryEisData } from "../app/slices/medDomain.slice";
import { addUniqueId } from "../utils/funcs";

export default (correlationId) => {
  const dispatch = useDispatch();
  const { medDomainBuildSummaryEisData } = useSelector(
    (state) => state.medDomain
  );

  const { data, isLoading, isFetching, isError, error, refetch } =
    useGetMedDomainEISBuildSummaryByIdQuery(correlationId, {
      skip: !correlationId,
    });

  useEffect(() => {
    if (Array.isArray(data)) {
      dispatch(setMedDomainBuildSummaryEisData(addUniqueId(data)));
    }
  }, [data, dispatch]);

  return {
    state: {
      medDomainBuildSummaryEisData,
    },
    isLoadingSummary: isLoading || isFetching,
    isErrorSummary: isError,
    errorSummary: error,
    refetchSummary: refetch,
  };
};
